import React, { Component } from "react";
import pdf from "views/profile/img/profile/pdf.png";
import close from "views/profile/img/profile/close.png";
import shareto from "views/job-details/img/upload.png";
import share from "views/profile/img/profile/share.png";
import { connect } from "react-redux";
import {
  uploadAppResumeMgAction,
  uploadResume,
  setCurrentResumeAction,
  parseResume,
} from "store/Profile";
import { setBasicAction } from "store/userWalkthrough";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import FileBase64 from "react-file-base64";
import resumeview from "views/job-details/img/doc+ms+office+word+icon-1320185650351265423_256.png";
import { Maximize } from "react-feather";
import { getMonth, getYear } from "date-fns";
import range from "lodash/range";
// import Base64Downloader from 'react-base64-downloader';
import { getapplicationSummary } from "store/SingleJob";
// import DocViewer from "react-doc-viewer";
import {
  checkSignup,
  createNewUser,
  login,
  registration,
  loginHC,
  setHCIDAction,
  SaveCandidateId,
  setLoader,
  SaveWhatsapp,
} from "store/Auth";
class Resume extends Component {
  constructor(props) {
    super(props);

    this.state = {
      resumeUpload: {
        FirstName: "",
        LastName: "",
        MobileNumber: "",
        DateofBirth: "",
        Email: "",
      },
      Gender: "",
      DateofBirth: "",
      DOB: "",
      Email: "",
      FirstName: "",
      Gender: 0,
      LastName: "",
      MiddleName: "",
      Mobile: "",
      PAN: "",
      Photo: "",
      Salutation: "",
      ResumeName: "",
      ResumeBase64: "",
      isCheck: true,
      ResumeLogo: "",
    };
  }

  componentDidMount() {}
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.BASICDETAILS !== this.props.BASICDETAILS) {
      this.prefillInfo();
    }
  }
  prefillInfo() {
    this.setState({
      Salutation: this.props.BASICDETAILS
        ? this.props.BASICDETAILS.Data.Salutation
        : "",
      FirstName: this.props.BASICDETAILS
        ? this.props.BASICDETAILS.Data.FirstName
        : "",
      // MiddleName: this.props.BASICDETAILS ? this.props.BASICDETAILS.Data.MiddleName : "",
      LastName: this.props.BASICDETAILS
        ? this.props.BASICDETAILS.Data.LastName
        : "",
      Mobile: this.props.BASICDETAILS
        ? this.props.BASICDETAILS.Data.Mobile
        : "",
      // Mobile: this.props.Auth.USER_DETAILS_MG ? this.props.Auth.USER_DETAILS_MG.MobileNo : "",
      Email: this.props.BASICDETAILS ? this.props.BASICDETAILS.Data.Email : "",
      DOB: this.props.BASICDETAILS
        ? new Date(this.props.BASICDETAILS.Data.DOB).getFullYear() >= 1990
          ? new Date(this.props.BASICDETAILS.Data.DOB)
          : ""
        : "",
      Gender: this.props.BASICDETAILS
        ? this.props.BASICDETAILS.Data.Gender
        : "",
    });
  }

  checkJobAppliedorNot(JOBID) {
    try {
      const element = this.props.ApplicationSummary.Data.JobsData.find(
        (value) => {
          return value.JobCode == JOBID;
        }
      );
      return !!element;
    } catch (error) {
      console.log(error);
    }
  }

  onHandleSubmitChange = async (event) => {
    event.preventDefault();

    try {
      let re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      const {
        FirstName,
        MiddleName,
        LastName,
        Mobile,
        Email,
        DOB,
        Gender,
        ResumeLogo,
      } = this.state;
      if (!FirstName) {
        alert("First name is mandatory");
        return false;
      }
      if (!LastName) {
        alert("Last name is mandatory");
        return false;
      }

      if (!Mobile || Mobile.length < 10 || Mobile.length > 10) {
        alert("Mobile number is mandatory");
        return false;
      }
      if (!Email || !re.test(Email)) {
        //if (!Email) {
        alert("Email is mandatory");
        return false;
      }

      if (!DOB) {
        alert("DOB is mandatory");
        return false;
      }
      if (!Gender) {
        alert("Gender is mandatory");
        return false;
      }
      // if (this.state.ResumeBase64) {
      //if base64 check condition start
      this.props.setLoader(true);

      let data = {
        SourceType: 1,
        RequestType: "Save Resume",
        EmpID: "",
        EmpMailID: "",
        FirstName: FirstName,
        MiddleName: MiddleName,
        LastName: LastName,
        MobileNumber: Mobile,
        EmailID: Email,
        Gender: Gender,
        DOB: new Date(DOB).toLocaleDateString(),
        FileName: this.state.ResumeName,
        ResumeDocument: this.state.ResumeBase64,
        isWhatsAppConsent: this.state.isCheck,
      };

      let response = await this.props.setBasicAction(data);

      this.props.setLoader(false);

      if (response.ResponseCode == 100) {
        // let payloadHC = response.CandidateID;
        let payloadHC = response.ResponseMessage.split(":")[1];
        let responseHC = this.props.setHCIDAction(payloadHC);
        alert(
          "Please click on 'NEXT' button to fill your contact and education details"
        );
        // let id = this.props.HCUSERID;
        // let payload = {
        //   RID: "",
        //   UserID: id,
        //   WhatsappMobileNo: Mobile,
        //   IsConsent: this.state.isCheck,
        //   EmployeeID: "",
        // };
        // let submit = await this.props.whatsappconsent(payload);
      } else if (response.ResponseCode == 101) {
        try {
          let payloadHC = response.ResponseMessage.split(":")[1];
          let responseHC = this.props.setHCIDAction(payloadHC);
          await this.props.getapplicationSummary(payloadHC);
          if (this.checkJobAppliedorNot(this.props.CurrentJob[0].JobNumber)) {
            window.location.reload();
            alert("Job Already Applied");
          }
          // alert("Already Applied");
        } catch (error) {
          alert("Something went wrong");
        }
      }
      // } //if base64 check condition end
      // else {
      //   //else base64 check condition start
      //   // alert("Please Upload Resume");

      // } //else base64 check condition end
    } catch (error) {
      //try end
      this.props.setLoader(false);
    }
  };

  async getFiles(files) {
    debugger;
    try {
      if (
        files.type == "application/pdf" ||
        files.type == "application/msword" ||
        files.type == "" ||
        files.type ==
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
      ) {
        if (parseInt(files.size) <= 5000) {
          this.setState({
            files: files,
            ResumeBase64: files.base64.split(",")[1],
            ResumeName: files.name,
            ResumeLogo: files.type,
          });
          let obj = {
            Data: {
              FileName: files.name,
              FileData: files.base64.split(",")[1],
            },
          };
          await this.props.setCurrentResumeAction(obj);
          this.props.setLoader(true);

          await this.props.parseResume(obj.Data);
          this.parseResumeSet();
          this.props.setLoader(false);
        } else {
          alert("file size must be less then 5mb ");
        }
      } else {
        alert("please upload resume in pdf or docs");
      }
    } catch (error) {
      this.props.setLoader(false);
    }
  }
  async getFilesResumeReUpload(files) {
    try {
      this.setState({
        files: files,
        ResumeBase64: files.base64.split(",")[1],
        ResumeName: files.name,
      });
      var obj = {
        CandidateNo: this.props.HCUSERID,
        FileName: files.name,
        FileData: files.base64.split(",")[1],
      };
      let response = await this.props.uploadResume(obj);
      if (response.ResponseCode == 100) {
        alert(response.ResponseMessage);
      } else {
        alert(response.ResponseMessage);
      }
    } catch (error) {}
  }
  async parseResumeSet() {
    let lastName = this.props.PARSERESUME.Name.substr(
      this.props.PARSERESUME.Name.indexOf(" ") + 1
    );
    this.setState({
      // Salutation: this.props.BASICDETAILS
      //   ? this.props.BASICDETAILS.Data.Salutation
      //   : "",
      FirstName: this.props.PARSERESUME.Name.substr(
        0,
        this.props.PARSERESUME.Name.indexOf(" ")
      ),
      // MiddleName: this.props.BASICDETAILS
      //   ? this.props.BASICDETAILS.Data.MiddleName
      //   : "",
      // LastName: this.props.BASICDETAILS
      //   ? this.props.BASICDETAILS.Data.LastName
      //   : "",
      LastName: lastName,
      Mobile: this.props.PARSERESUME.Mobile,
      Email: this.props.PARSERESUME.EMail,
      DOB: this.props.PARSERESUME.DOB
        ? new Date(this.props.PARSERESUME.DOB)
        : "",
      Gender: this.props.PARSERESUME.Gender,
    });
  }

  getDate(dateString) {
    var today = new Date();
    var birthDate = new Date(dateString);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }

    if (age <= 18) {
      // alert("You must be 18 to apply for this job");
      console.log();
      return true;
    } else {
      return false;
    }
  }

  maxDate() {
    let eighteenYearsAgo = new Date();
    return (eighteenYearsAgo = eighteenYearsAgo.setFullYear(
      eighteenYearsAgo.getFullYear() - 18
    ));
  }

  b64toBlob(b64Data, contentType = "", sliceSize = 512) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    let blobURL = URL.createObjectURL(blob);
    return blobURL;
  }

  render() {
    // new Date(this.props.BASICDETAILS.Data.DOB)
    const years = [...range(1995, getYear(new Date()) - 17, 1)].reverse();
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const { FirstName, MiddleName, LastName, Mobile, Email, DOB, Gender } =
      this.state;
    return (
      <card className="rounded-12px bg-white block   mt-2">
        <div className="lg:flex md:flex  pb-6">
          <form action="" className="lg:w-7/12 md:w-7/12 ">
            <div className="">
              {this.state.ResumeName ? (
                <div className="modal-form-cs">
                  {/* <label for="">Uploaded</label> */}
                  <div className="flex justify-between items-center mt-2 mb-4">
                    <div className="flex items-center">
                      <img
                        src={
                          this.state.ResumeLogo == "application/pdf"
                            ? pdf
                            : resumeview
                        }
                        alt="pdf"
                        className="md:w-8 lg:w-8 w-5 md:h-8 lg:h-8 h-5 mr-3"
                      />
                      <span className="fsize16 text-black font-bold">
                        {this.state.ResumeName
                          ? this.state.ResumeName
                          : this.props.HCRESUME.Data
                          ? this.props.HCRESUME.Data.FileName
                          : " "}
                      </span>
                    </div>
                    {/* <div>
                      <img src={close} alt="close" className="cursor-pointer" />
                    </div> */}
                  </div>
                </div>
              ) : (
                ""
              )}
              <div className="">
                <p className="fsize14 text-center md:mt-2 lg:mt-2 mt-0 font-bold">
                  Upload of resume is optional. If you don’t have your resume
                  handy, please fill your basic details and click on ‘Save'.
                  Upload DOCX or PDF format with size upto 5 MB.
                </p>
                {!this.props.HCRESUME ? (
                  <div class="form-group mt-3  relative cursor-pointer  w-full h-432-200px justify-center resume-upload items-center flex  ">
                    <div className="flex justify-center items-center cursor-pointer w-full h-full">
                      <div className="filbase-uploader">
                        <img
                          src={shareto}
                          className="m-auto resume-share-w"
                          alt="shareto"
                        />

                        <FileBase64
                          accept=".docx,.pdf"
                          multiple={false}
                          onDone={this.getFiles.bind(this)}
                        ></FileBase64>
                        <p className="fsize16 text1B1B1B pt-6">
                          Drag and drop{" "}
                          <span className="textE77817 cursor-pointer underline font-semibold">
                            Browse
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                ) : this.props.HCRESUME.Data.FileName.includes(".pdf") ? (
                  <div class="form-group   cursor-pointer md:mb-8 lg:mb-8 mb-4 w-full h-350px justify-center  items-center flex">
                    <div className="img__whatnews w-full">
                      <div className="relative">
                        {/* <img
src={resumeview}
className="m-auto "
alt="shareto"
/> */}
                        {/* <iframe
                          className=" iframe-pdf-w"
                          src={this.b64toBlob(
                            this.state.ResumeBase64,
                            "application/pdf"
                          )}
                        ></iframe> */}
                        <iframe
                          className="m-auto iframe-pdf-w"
                          src={
                            "data:application/pdf;base64," +
                            this.props.HCRESUME.Data.FileData
                          }
                        ></iframe>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div class="form-group   cursor-pointer mb-8  w-full h-230px justify-center  items-center flex  ">
                    <div className="img__whatnews ">
                      <div className="relative">
                        <img
                          src={resumeview}
                          className="m-auto "
                          alt="shareto"
                        />

                        {/* <iframe
                          className="m-auto iframe-pdf-w"
                          src={
                            "data:application/octet-stream;base64," +
                            this.props.HCRESUME.Data.FileData
                          }
                        ></iframe> */}
                        {/* <iframe class="doc" src="https://docs.google.com/gview?url=http://writing.engr.psu.edu/workbooks/formal_report_template.doc&embedded=true"></iframe> */}
                        {/* <iframe src='//docs.google.com/gview?url=URLOFDOC.docx&embedded=true' frameborder='0'></iframe> */}
                        {/* <iframe src={`https://docs.google.com/gview?url=${this.props.HCRESUME.Data.FileData}&embedded=true`}></iframe> */}
                        {/* <DocViewer
                          documents={[
                            { uri: this.props.HCRESUME.Data.FileData },
                          ]}
                        /> */}
                      </div>
                      <div className="flex img__whatnews_layer justify-center items-center rounded-12px">
                        <div className=" text-center ">
                          <div className="flex justify-center items-center">
                            <p className="text-white font-semibold ml-2  fsize18">
                              <a
                                download={this.props.HCRESUME.Data.FileName}
                                href={
                                  "data:application/octet-stream;base64," +
                                  this.props.HCRESUME.Data.FileData
                                }
                              >
                                Download
                              </a>
                            </p>
                            <Maximize className="text-white ml-4" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              {this.props.HCRESUME ? (
                <div className="mt-12 text-center ">
                  <div className="mt-4 flex items-center justify-center relative items-center">
                    <div className="flex justify-center items-center cursor-pointer h-full">
                      <div className="filbase-uploader">
                        <p className="textE77817 fszie16 font-semibold uploade-hidden-v">
                          <FileBase64
                            accept=".docx,.pdf"
                            multiple={false}
                            onDone={this.getFiles.bind(this)}
                          >
                            Upload Resume
                          </FileBase64>
                          Reupload Resume
                        </p>
                      </div>
                    </div>
                    <img src={share} alt="shareto" className="w-5 h-5 ml-2" />
                  </div>
                </div>
              ) : (
                ""
              )}{" "}
            </div>
          </form>

          <div className="lg:w-5/12 md:w-5/12 lg:pl-6 md:pl-6">
            <div className="">
              <div className="lg:flex md:flex items-center">
                <div class="form-group modal-form-cs lg:w-1/2 md:w-1/2 lg:pr-3 md:pr-3 lg:pt-0 md:pt-0 pt-4">
                  <label for="">
                    First Name <span className="text-red">*</span>
                  </label>
                  <input
                    type="text"
                    value={FirstName}
                    required="required"
                    onChange={(e) =>
                      // this.setState({
                      //   resumeUpload: {
                      //     ...resumeUpload,
                      //     FirstName: e.target.value,
                      //   },
                      // })
                      this.setState({
                        FirstName: e.target.value
                          .replace(/[^\w\s]/gi, "")
                          .replace(/[^A-Za-z]/gi, ""),
                      })
                    }
                    placeholder=""
                  />
                </div>
                {/* <div class="form-group modal-form-cs lg:w-1/2 md:w-1/2 lg:pl-3 md:pl-3 lg:pt-0 md:pt-0 pt-4">
                  <label for="">Middle Name</label>
                  <input
                    type="text"
                    value={MiddleName}
                    onChange={(e) =>
                      this.setState({
                        MiddleName: e.target.value,
                      })
                    }
                    placeholder=""
                  />
                </div> */}
                <div class="form-group modal-form-cs lg:w-1/2 md:w-1/2 lg:pl-3 md:pl-3 lg:pt-0 md:pt-0 pt-4">
                  <label for="">
                    Last Name <span className="text-red">*</span>
                  </label>
                  <input
                    type="text"
                    value={LastName}
                    required="required"
                    onChange={(e) =>
                      this.setState({
                        LastName: e.target.value
                          .replace(/[^\w\s]/gi, "")
                          .replace(/[^A-Za-z]/gi, ""),
                      })
                    }
                    placeholder=""
                  />
                </div>
              </div>

              <div class="form-group pt-4 modal-form-cs">
                <label for="">
                  Mobile Number <span className="text-red">*</span>
                </label>
                <input
                  type="phone"
                  // disabled={true}
                  value={Mobile}
                  required="required"
                  onChange={(e) => {
                    if (e.target.value.length <= 10) {
                      this.setState({
                        Mobile: e.target.value.replace(/[^\d]/g, ""),
                      });
                    }
                  }}
                  placeholder=""
                />
              </div>

              <div class="form-group pt-4 modal-form-cs">
                <label for="">
                  Date of birth <span className="text-red">*</span>
                </label>
                <div className="datepicker-w-full">
                  <DatePicker
                    renderCustomHeader={({
                      date,
                      changeYear,
                      changeMonth,
                      decreaseMonth,
                      increaseMonth,
                      prevMonthButtonDisabled,
                      nextMonthButtonDisabled,
                    }) => (
                      <div
                        style={{
                          margin: 10,
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <select
                          value={getYear(date)}
                          onChange={({ target: { value } }) =>
                            changeYear(value)
                          }
                        >
                          {years.map((option) => (
                            <option key={option} value={option}>
                              {option}
                            </option>
                          ))}
                        </select>

                        <select
                          value={months[getMonth(date)]}
                          onChange={({ target: { value } }) =>
                            changeMonth(months.indexOf(value))
                          }
                        >
                          {months.map((option) => (
                            <option key={option} value={option}>
                              {option}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}
                    selected={DOB}
                    className="w-full"
                    dateFormat="dd/MM/yyyy"
                    maxDate={this.maxDate()}
                    getDate={this.getDate(DOB)}
                    onChange={(date) => this.setState({ DOB: date })}
                  />
                </div>
              </div>

              <div class="form-group pt-4 modal-form-cs">
                <label for="">
                  Email <span className="text-red">*</span>
                </label>
                <input
                  //type="text"
                  type="email"
                  value={Email}
                  onChange={(e) =>
                    this.setState({
                      Email: e.target.value,
                    })
                  }
                  placeholder=""
                />
              </div>
              <div class="form-group pt-4 modal-form-cs">
                <label for="">
                  Gender <span className="text-red">*</span>
                </label>
                <select
                  value={Gender || this.props.PARSERESUME.Gender}
                  onChange={(e) => {
                    this.setState({
                      Gender: e.target.value,
                    });
                  }}
                  className="select-dropdown-c"
                >
                  <option value={"0"}>Not Defined</option>
                  <option value={"2"}>Male</option>
                  <option value="1">Female</option>
                </select>
              </div>

              <div className="pt-5 flex items-center ">
                <label class="custcheckbox">
                  <p className="cb-label">
                    I authorize ICICI Bank to send notifications on WhatsApp.
                  </p>
                  <input
                    id="checkmecb"
                    type="checkbox"
                    defaultChecked={this.state.isCheck}
                    onChange={() =>
                      this.setState({ isCheck: !this.state.isCheck })
                    }
                  />
                  <span class="overhide-span top-5px"></span>
                </label>
              </div>

              <div class="w-full flex justify-end mt-4">
                {this.props.HCUSERID ? (
                  ""
                ) : (
                  <div>
                    <button
                      class="btn btn-filled btn-width-sm"
                      // disabled={this.getDate(DOB) ? "disabled" : ""} commented for resume check
                      onClick={
                        !this.props.HCUSERID || true
                          ? this.onHandleSubmitChange
                          : ""
                      }
                    >
                      {this.props.HCUSERID ? "" : "Save"}
                    </button>
                  </div>
                )}

                {/* 
                  <div class="w-full  flex justify-end f-full lg:mt-16 md:mt-16 mt-12">
                    {!this.props.HCUSERID ?
                      <button
                        class="btn orange-button btn-otp font-medium fsize16 myBtn" disabled={this.getDate(DOB) ? 'disabled' : ''}
                        onClick={
                          !this.props.HCUSERID
                            ? this.onHandleSubmitChange
                            : this.updateBasicdetails
                        }
                      >
                        Save
                </button>
                      : ""}
                  </div> */}
                {/* </button> */}
              </div>
            </div>
          </div>
        </div>
      </card>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    Auth: state.Auth.user,
    BASICDETAILS: state.userWalkthrough.info.BASICDETAILS,
    HCUSERID: state.Auth.user.HCID,
    HCRESUME: state.Profile.home.CURRENTRESUME,
    PARSERESUME: state.Profile.home.PARSERESUME
      ? state.Profile.home.PARSERESUME.Data.Document
      : "",
    ApplicationSummary: state.SingleJob.home.APPLICATIONSUMMARY,
    CurrentJob: state.SingleJob.home.CURRENTJOB.Data,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    uploadAppResumeMgAction: (payload) => {
      dispatch(uploadAppResumeMgAction(payload));
    },
    setBasicAction: (payload) => dispatch(setBasicAction(payload)),
    setHCIDAction: async (payload) => await dispatch(setHCIDAction(payload)),
    uploadResume: async (payload) => await dispatch(uploadResume(payload)),
    setLoader: async (flag) => await dispatch(setLoader(flag)),
    setCurrentResumeAction: async (flag) =>
      await dispatch(setCurrentResumeAction(flag)),
    parseResume: async (flag) => await dispatch(parseResume(flag)),
    getapplicationSummary: async (payload) =>
      await dispatch(getapplicationSummary(payload)),
    whatsappconsent: async (payload) => await dispatch(SaveWhatsapp(payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Resume);
